var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustimg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 60C120 109.264 109.264 120 60 120C10.7357 120 0 109.264 0 60C0 10.7357 10.7357 0 60 0C109.264 0 120 10.7357 120 60Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3651 48.0409C56.3651 45.6771 58.3345 43.7749 60.7234 43.884C62.8411 43.9819 64.5866 45.7246 64.6846 47.8451C64.7657 49.5906 63.7698 51.1124 62.3068 51.8034C60.0465 52.872 57.8141 53.9993 55.7301 55.3813L45.7126 62.0195C44.3391 62.7104 43.3936 64.1343 43.3936 65.7708C43.3936 68.0787 45.2818 69.9669 47.5897 69.9669H72.7662C75.0741 69.9669 76.9623 68.0787 76.9623 65.7708C76.9623 63.849 75.6504 62.2153 73.8796 61.7258L65.3531 58.3745C64.2062 57.9241 62.9166 58.0304 61.8592 58.6654L52.3452 64.3749",
    stroke: "#0A090A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 47.125V72.875C35 74.4332 35.8112 75.8822 37.1428 76.6935L57.8436 89.3433C59.2758 90.2189 61.0773 90.2189 62.5124 89.3433L83.2132 76.6935C84.5447 75.8794 85.356 74.4332 85.356 72.875V47.125C85.356 45.5668 84.5447 44.1178 83.2132 43.3065L62.5096 30.6567C61.0773 29.7811 59.2758 29.7811 57.8408 30.6567L37.1428 43.3065C35.8112 44.1206 35 45.5668 35 47.125Z",
    stroke: "#0A090A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustimg3);
export default __webpack_public_path__ + "static/media/trustimg3.74afc27073f24bd8beb61b26a1fae212.svg";
export { ForwardRef as ReactComponent };